import React, { useState } from 'react';

import ReactDOM from 'react-dom';
import { useForm } from "react-hook-form";

function SampleForm() {
  const { register, handleSubmit, watch, errors, setError, formState } = useForm();
  // useForm({
  //   mode: 'onSubmit',
  //   defaultValues: {
  //     "email": "email@email.com",
  //     "firstName": "firstName",
  //     "lastName": "lastName",
  //     "phone": "53454356",
  //     "birthDate": "04/04/1980",
  //     "address": "Address",
  //     "city": "City",
  //     "country": "AFG",
  //     "zipCode": "3445",
  //     "studies": "Secondary education",
  //     "qualifications": "qualifications",
  //     "interests": [
  //       "comercial",
  //       "fabricacion",
  //       "oficina-tecnica"
  //     ],
  //     "languages": [
  //       "english"
  //     ],
  //     // "file": {
  //     //   "0": {}
  //     // },
  //     // "file-2": {},
  //     "coverLetter": "coverLetter",
  //     "accept": true
  //   }
  // });

  let [emailMessage, setEmailMessage] = useState('');
  let [isLoading, setisLoading] = useState(false);

  const onLoad = () => {
    setTimeout(() => {
      $("*").each(function () {
        if (kn_translation) {
          if (kn_translation[$(this).attr('for')]) $(this).html(kn_translation[$(this).attr('for')]);
          if (kn_translation[$(this).data('trans')]) $(this).html(kn_translation[$(this).data('trans')]);
          if (kn_translation[$(this).attr('value')]) $(this).html(kn_translation[$(this).attr('value')]);
          if ($(this).data('trans') === "terms_and_conditions") $(this).attr("href", kn_variables.privacy_url);
        }
      })
    }, 1)
  };

  const onSubmit = data => {

    document.getElementById("submit").disabled = true;
    
    setisLoading(true);

    let formData = new FormData();

    // Ou, usando array extras
    Object.entries(data).forEach(([key, value]) => {

      if (key.search('file') === 0)
        formData.append(key, value[0]);
      else
        formData.append(key, value);
    });
    
    var pageUrl = window.location.href.replace(/^(?:\/\/|[^\/]+)*\//, "");
    pageUrl = pageUrl.substring(0, pageUrl.length - 1);
    formData.append('pageTitle', pageUrl);

    formData.append('action', 'kn_upload_file');

    $.ajax({
        url: kn_variables.ajaxurl,
        type: 'POST',
        data: formData,
        success: function (res) {
          const result = JSON.parse(res);

          if (result.success === false) {
            if (result.error_files) {
              result.error_files.forEach(file => {

                setError(file.file_id, "serverError", file.error);
                  console.log(errors);

              });
            }
          } else {
            
            setEmailMessage(result);

            if (kn_form_3 && kn_form_3.success_url)
              window.location.href = kn_form_3.success_url + window.location.search;
            else
              window.location.href = "/thanks-cv/";
          }

          setisLoading(false);

        },
        cache: false,
        contentType: false,
        processData: false
    });

    // console.log(JSON.stringify(data));
  };

  return (
    <div className="App">
      <form onLoad={onLoad()} onSubmit={handleSubmit(onSubmit)}>

        <fieldset>
          <legend data-trans="step1">STEP 1</legend>
          <h3 class="fieldset-title" data-trans="personal_info">Personal information</h3>

          <div>
            <label htmlFor="email" class="input-label">Email</label>
            <input name="email" id="email" placeholder="" type="email" ref={register({ required: true, maxLength:50, pattern: {value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: "invalid email address"} })} />
            {errors.email && errors.email.type === "required" && <span class="field-required">*Required</span>}
            {errors.email && errors.email.type === "maxLength" && <span class="field-required">*50 characters maximum</span> }
          </div>

          <div class="form-div-50-width-left">
            <label htmlFor="firstName" class="input-label">First name</label>
            <input name="firstName" id="firstName" type="text" ref={register({ required: true, maxLength:50 })} />
            {errors.firstName && errors.firstName.type === "required" && <span class="field-required">*Required</span>}
            {errors.firstName && errors.firstName.type === "maxLength" && <span class="field-required">*50 characters maximum</span> }
          </div>

          <div class="form-div-50-width-right">
            <label htmlFor="lastName" class="input-label">Last name</label>
            <input name="lastName" id="lastName" type="text" ref={register({ required: true, maxLength:50 })} />
            {errors.lastName && errors.lastName.type === "required" && <span class="field-required">*Required</span>}
            {errors.lastName && errors.lastName.type === "maxLength" && <span class="field-required">*50 characters maximum</span> }
          </div>

          <div class="form-div-50-width-left">
            <label htmlFor="phone" class="input-label">Phone</label>
            <input name="phone" id="phone" type="tel" ref={register({ required: true, minLength: 6, maxLength: 12 })} />
            {errors.phone && errors.phone.type === "required" && <span class="field-required">*Required</span>}
          </div>

          <div class="form-div-50-width-right">
            <label htmlFor="birthDate" class="input-label">Date of birth</label>
            <input name="birthDate" id="birthDate" type="text" ref={register({ required: true })} />
            {/*errors.birthDate && errors.birthDate.type === "required" && <span class="field-required">*Required</span>*/}
          </div>

          <div class="form-div-50-width-left">
            <label htmlFor="address" class="input-label">Address</label>
            <input name="address" id="address" type="text" ref={register({ required: true, maxLength: 100 })} />
            {errors.address && errors.address.type === "required" && <span class="field-required">*Required</span>}
            {errors.address && errors.address.type === "maxLength" && <span class="field-required">*100 characters maximum</span> }
          </div>

          <div class="form-div-50-width-right">
            <label htmlFor="city" class="input-label">City</label>
            <input name="city" id="city" type="text" ref={register({ required: true, maxLength:50 })} />
            {errors.city && errors.city.type === "required" && <span class="field-required">*Required</span>}
            {errors.city && errors.city.type === "maxLength" && <span class="field-required">*50 characters maximum</span> }
          </div>

          <div class="form-div-50-width-left">
            <label htmlFor="country" class="input-label">Country</label>
            <select name="country" id="country" ref={register({ required: true })}>
              <option value="" selected={true} disabled="disabled" data-trans="pleaseSelect">- Please select -</option>
              <option value="AFG">Afghanistan</option>
              <option value="ALA">Åland Islands</option>
              <option value="ALB">Albania</option>
              <option value="DZA">Algeria</option>
              <option value="ASM">American Samoa</option>
              <option value="AND">Andorra</option>
              <option value="AGO">Angola</option>
              <option value="AIA">Anguilla</option>
              <option value="ATA">Antarctica</option>
              <option value="ATG">Antigua and Barbuda</option>
              <option value="ARG">Argentina</option>
              <option value="ARM">Armenia</option>
              <option value="ABW">Aruba</option>
              <option value="AUS">Australia</option>
              <option value="AUT">Austria</option>
              <option value="AZE">Azerbaijan</option>
              <option value="BHS">Bahamas</option>
              <option value="BHR">Bahrain</option>
              <option value="BGD">Bangladesh</option>
              <option value="BRB">Barbados</option>
              <option value="BLR">Belarus</option>
              <option value="BEL">Belgium</option>
              <option value="BLZ">Belize</option>
              <option value="BEN">Benin</option>
              <option value="BMU">Bermuda</option>
              <option value="BTN">Bhutan</option>
              <option value="BOL">Bolivia, Plurinational State of</option>
              <option value="BES">Bonaire, Sint Eustatius and Saba</option>
              <option value="BIH">Bosnia and Herzegovina</option>
              <option value="BWA">Botswana</option>
              <option value="BVT">Bouvet Island</option>
              <option value="BRA">Brazil</option>
              <option value="IOT">British Indian Ocean Territory</option>
              <option value="BRN">Brunei Darussalam</option>
              <option value="BGR">Bulgaria</option>
              <option value="BFA">Burkina Faso</option>
              <option value="BDI">Burundi</option>
              <option value="KHM">Cambodia</option>
              <option value="CMR">Cameroon</option>
              <option value="CAN">Canada</option>
              <option value="CPV">Cape Verde</option>
              <option value="CYM">Cayman Islands</option>
              <option value="CAF">Central African Republic</option>
              <option value="TCD">Chad</option>
              <option value="CHL">Chile</option>
              <option value="CHN">China</option>
              <option value="CXR">Christmas Island</option>
              <option value="CCK">Cocos (Keeling) Islands</option>
              <option value="COL">Colombia</option>
              <option value="COM">Comoros</option>
              <option value="COG">Congo</option>
              <option value="COD">Congo, the Democratic Republic of the</option>
              <option value="COK">Cook Islands</option>
              <option value="CRI">Costa Rica</option>
              <option value="CIV">Côte d'Ivoire</option>
              <option value="HRV">Croatia</option>
              <option value="CUB">Cuba</option>
              <option value="CUW">Curaçao</option>
              <option value="CYP">Cyprus</option>
              <option value="CZE">Czech Republic</option>
              <option value="DNK">Denmark</option>
              <option value="DJI">Djibouti</option>
              <option value="DMA">Dominica</option>
              <option value="DOM">Dominican Republic</option>
              <option value="ECU">Ecuador</option>
              <option value="EGY">Egypt</option>
              <option value="SLV">El Salvador</option>
              <option value="GNQ">Equatorial Guinea</option>
              <option value="ERI">Eritrea</option>
              <option value="EST">Estonia</option>
              <option value="ETH">Ethiopia</option>
              <option value="FLK">Falkland Islands (Malvinas)</option>
              <option value="FRO">Faroe Islands</option>
              <option value="FJI">Fiji</option>
              <option value="FIN">Finland</option>
              <option value="FRA">France</option>
              <option value="GUF">French Guiana</option>
              <option value="PYF">French Polynesia</option>
              <option value="ATF">French Southern Territories</option>
              <option value="GAB">Gabon</option>
              <option value="GMB">Gambia</option>
              <option value="GEO">Georgia</option>
              <option value="DEU">Germany</option>
              <option value="GHA">Ghana</option>
              <option value="GIB">Gibraltar</option>
              <option value="GRC">Greece</option>
              <option value="GRL">Greenland</option>
              <option value="GRD">Grenada</option>
              <option value="GLP">Guadeloupe</option>
              <option value="GUM">Guam</option>
              <option value="GTM">Guatemala</option>
              <option value="GGY">Guernsey</option>
              <option value="GIN">Guinea</option>
              <option value="GNB">Guinea-Bissau</option>
              <option value="GUY">Guyana</option>
              <option value="HTI">Haiti</option>
              <option value="HMD">Heard Island and McDonald Islands</option>
              <option value="VAT">Holy See (Vatican City State)</option>
              <option value="HND">Honduras</option>
              <option value="HKG">Hong Kong</option>
              <option value="HUN">Hungary</option>
              <option value="ISL">Iceland</option>
              <option value="IND">India</option>
              <option value="IDN">Indonesia</option>
              <option value="IRN">Iran, Islamic Republic of</option>
              <option value="IRQ">Iraq</option>
              <option value="IRL">Ireland</option>
              <option value="IMN">Isle of Man</option>
              <option value="ISR">Israel</option>
              <option value="ITA">Italy</option>
              <option value="JAM">Jamaica</option>
              <option value="JPN">Japan</option>
              <option value="JEY">Jersey</option>
              <option value="JOR">Jordan</option>
              <option value="KAZ">Kazakhstan</option>
              <option value="KEN">Kenya</option>
              <option value="KIR">Kiribati</option>
              <option value="PRK">Korea, Democratic People's Republic of</option>
              <option value="KOR">Korea, Republic of</option>
              <option value="KWT">Kuwait</option>
              <option value="KGZ">Kyrgyzstan</option>
              <option value="LAO">Lao People's Democratic Republic</option>
              <option value="LVA">Latvia</option>
              <option value="LBN">Lebanon</option>
              <option value="LSO">Lesotho</option>
              <option value="LBR">Liberia</option>
              <option value="LBY">Libya</option>
              <option value="LIE">Liechtenstein</option>
              <option value="LTU">Lithuania</option>
              <option value="LUX">Luxembourg</option>
              <option value="MAC">Macao</option>
              <option value="MKD">Macedonia, the former Yugoslav Republic of</option>
              <option value="MDG">Madagascar</option>
              <option value="MWI">Malawi</option>
              <option value="MYS">Malaysia</option>
              <option value="MDV">Maldives</option>
              <option value="MLI">Mali</option>
              <option value="MLT">Malta</option>
              <option value="MHL">Marshall Islands</option>
              <option value="MTQ">Martinique</option>
              <option value="MRT">Mauritania</option>
              <option value="MUS">Mauritius</option>
              <option value="MYT">Mayotte</option>
              <option value="MEX">Mexico</option>
              <option value="FSM">Micronesia, Federated States of</option>
              <option value="MDA">Moldova, Republic of</option>
              <option value="MCO">Monaco</option>
              <option value="MNG">Mongolia</option>
              <option value="MNE">Montenegro</option>
              <option value="MSR">Montserrat</option>
              <option value="MAR">Morocco</option>
              <option value="MOZ">Mozambique</option>
              <option value="MMR">Myanmar</option>
              <option value="NAM">Namibia</option>
              <option value="NRU">Nauru</option>
              <option value="NPL">Nepal</option>
              <option value="NLD">Netherlands</option>
              <option value="NCL">New Caledonia</option>
              <option value="NZL">New Zealand</option>
              <option value="NIC">Nicaragua</option>
              <option value="NER">Niger</option>
              <option value="NGA">Nigeria</option>
              <option value="NIU">Niue</option>
              <option value="NFK">Norfolk Island</option>
              <option value="MNP">Northern Mariana Islands</option>
              <option value="NOR">Norway</option>
              <option value="OMN">Oman</option>
              <option value="PAK">Pakistan</option>
              <option value="PLW">Palau</option>
              <option value="PSE">Palestinian Territory, Occupied</option>
              <option value="PAN">Panama</option>
              <option value="PNG">Papua New Guinea</option>
              <option value="PRY">Paraguay</option>
              <option value="PER">Peru</option>
              <option value="PHL">Philippines</option>
              <option value="PCN">Pitcairn</option>
              <option value="POL">Poland</option>
              <option value="PRT">Portugal</option>
              <option value="PRI">Puerto Rico</option>
              <option value="QAT">Qatar</option>
              <option value="REU">Réunion</option>
              <option value="ROU">Romania</option>
              <option value="RUS">Russian Federation</option>
              <option value="RWA">Rwanda</option>
              <option value="BLM">Saint Barthélemy</option>
              <option value="SHN">Saint Helena, Ascension and Tristan da Cunha</option>
              <option value="KNA">Saint Kitts and Nevis</option>
              <option value="LCA">Saint Lucia</option>
              <option value="MAF">Saint Martin (French part)</option>
              <option value="SPM">Saint Pierre and Miquelon</option>
              <option value="VCT">Saint Vincent and the Grenadines</option>
              <option value="WSM">Samoa</option>
              <option value="SMR">San Marino</option>
              <option value="STP">Sao Tome and Principe</option>
              <option value="SAU">Saudi Arabia</option>
              <option value="SEN">Senegal</option>
              <option value="SRB">Serbia</option>
              <option value="SYC">Seychelles</option>
              <option value="SLE">Sierra Leone</option>
              <option value="SGP">Singapore</option>
              <option value="SXM">Sint Maarten (Dutch part)</option>
              <option value="SVK">Slovakia</option>
              <option value="SVN">Slovenia</option>
              <option value="SLB">Solomon Islands</option>
              <option value="SOM">Somalia</option>
              <option value="ZAF">South Africa</option>
              <option value="SGS">South Georgia and the South Sandwich Islands</option>
              <option value="SSD">South Sudan</option>
              <option value="ESP">Spain</option>
              <option value="LKA">Sri Lanka</option>
              <option value="SDN">Sudan</option>
              <option value="SUR">Suriname</option>
              <option value="SJM">Svalbard and Jan Mayen</option>
              <option value="SWZ">Swaziland</option>
              <option value="SWE">Sweden</option>
              <option value="CHE">Switzerland</option>
              <option value="SYR">Syrian Arab Republic</option>
              <option value="TWN">Taiwan, Province of China</option>
              <option value="TJK">Tajikistan</option>
              <option value="TZA">Tanzania, United Republic of</option>
              <option value="THA">Thailand</option>
              <option value="TLS">Timor-Leste</option>
              <option value="TGO">Togo</option>
              <option value="TKL">Tokelau</option>
              <option value="TON">Tonga</option>
              <option value="TTO">Trinidad and Tobago</option>
              <option value="TUN">Tunisia</option>
              <option value="TUR">Turkey</option>
              <option value="TKM">Turkmenistan</option>
              <option value="TCA">Turks and Caicos Islands</option>
              <option value="TUV">Tuvalu</option>
              <option value="UGA">Uganda</option>
              <option value="UKR">Ukraine</option>
              <option value="ARE">United Arab Emirates</option>
              <option value="GBR">United Kingdom</option>
              <option value="USA">United States</option>
              <option value="UMI">United States Minor Outlying Islands</option>
              <option value="URY">Uruguay</option>
              <option value="UZB">Uzbekistan</option>
              <option value="VUT">Vanuatu</option>
              <option value="VEN">Venezuela, Bolivarian Republic of</option>
              <option value="VNM">Viet Nam</option>
              <option value="VGB">Virgin Islands, British</option>
              <option value="VIR">Virgin Islands, U.S.</option>
              <option value="WLF">Wallis and Futuna</option>
              <option value="ESH">Western Sahara</option>
              <option value="YEM">Yemen</option>
              <option value="ZMB">Zambia</option>
              <option value="ZWE">Zimbabwe</option>
            </select>
            {errors.country && errors.country.type === "required" && <span class="field-required">*Required</span>}
          </div>

          <div class="form-div-50-width-right">
            <label htmlFor="zipCode" class="input-label">Zip Field</label>
            <input name="zipCode" id="zipCode" type="text" ref={register({ required: true, maxLength: 8 })} />
            {errors.zipCode && errors.zipCode.type === "required" && <span class="field-required">*Required</span>}
            {errors.zipCode && errors.zipCode.type === "maxLength" && <span class="field-required">*8 characters maximum</span> }
          </div>

        </fieldset>

        <fieldset>
          <legend data-trans="step2">STEP 2</legend>
          <h3 class="fieldset-title" data-trans="education">Education</h3>

          <div>
            <label htmlFor="studies" class="input-label">Studies</label>
            <select name="studies" id="studies" ref={register({ required: true })}>
              <option value="" selected={true} disabled="disabled" data-trans="pleaseSelect">- Please select -</option>
              <option data-trans="studies1" value="No formal education">No formal education</option>
              <option data-trans="studies2" value="Primary education">Primary education</option>
              <option data-trans="studies3" value="Secondary education">Secondary education or high school</option>
              <option data-trans="studies4" value="GED">GED</option>
              <option data-trans="studies5" value="Vocational qualification">Vocational qualification</option>
              <option data-trans="studies6" value="Bachelor's degree">Bachelor's degree</option>
              <option data-trans="studies7" value="Master's degree">Master's degree</option>
              <option data-trans="studies8" value="Doctorate or higher">Doctorate or higher</option>
            </select>
            {errors.studies && errors.studies.type === "required" && <span class="field-required">*Required</span>}
          </div>

          <div>
            <label htmlFor="qualifications" class="input-label">Other qualifications</label>
            <input name="qualifications" id="qualifications" type="tel" ref={register({ required: true})} />
            {errors.qualifications && errors.qualifications.type === "required" && <span class="field-required">*Required</span>}
          </div>

        </fieldset>

        <fieldset>
          <legend data-trans="step3">STEP 3</legend>
          <h3 class="fieldset-title" data-trans="additional_info">Additional information</h3>

          <h4 class="checkbox-title" data-trans="areasinteres">Áreas de interés</h4>
          <div class="checkbox-column">
            <label><input type="checkbox" name="interests" value="finanzas" ref={register} /><span data-trans="finanzas">Finance</span></label>
            <label><input type="checkbox" name="interests" value="gestion-proyectos" ref={register} /><span data-trans="gestion-proyectos">Project Management</span></label>
            <label><input type="checkbox" name="interests" value="comercial" ref={register} /><span data-trans="comercial">Sales</span></label>
            <label><input type="checkbox" name="interests" value="diseño" ref={register} /><span data-trans="diseño">Design</span></label>
            <label><input type="checkbox" name="interests" value="marketing" ref={register} /><span data-trans="marketing">Marketing</span></label>
          </div>
          <div class="checkbox-column">
            <label><input type="checkbox" name="interests" value="i+d" ref={register} /><span data-trans="i+d">R&D</span></label>
            <label><input type="checkbox" name="interests" value="fabricacion" ref={register} /><span data-trans="fabricacion">Manufacturing</span></label>
            <label><input type="checkbox" name="interests" value="confeccion" ref={register} /><span data-trans="confeccion">Sewing</span></label>
            <label><input type="checkbox" name="interests" value="impresion" ref={register} /><span data-trans="impresion">Printing</span></label>
            <label><input type="checkbox" name="interests" value="it" ref={register} /><span data-trans="it">IT</span></label>
          </div>
          <div class="checkbox-column">
            <label><input type="checkbox" name="interests" value="rrhh" ref={register} /><span data-trans="rrhh">Human Resources</span></label>
            <label><input type="checkbox" name="interests" value="oficina-tecnica" ref={register} /><span data-trans="oficina-tecnica">Technical Design</span></label>
            <label><input type="checkbox" name="interests" value="compras" ref={register} /><span data-trans="compras">Purchasing</span></label>
            <label><input type="checkbox" name="interests" value="logistica" ref={register} /><span data-trans="logistica">Logistics</span></label>
            <label><input type="checkbox" name="interests" value="other" ref={register} /><span data-trans="other">Other</span></label>
          </div>

          <h4 class="checkbox-title" data-trans="idiomas">Idiomas</h4>
          <div class="checkbox-column">
            <label><input type="checkbox" name="languages" value="euskera" ref={register} /><span data-trans="euskera">Basque</span></label>
            <label><input type="checkbox" name="languages" value="english" ref={register} /><span data-trans="english">English</span></label>
            <label><input type="checkbox" name="languages" value="french" ref={register} /><span data-trans="french">French</span></label>
            <label><input type="checkbox" name="languages" value="german" ref={register} /><span data-trans="german">German</span></label>
            <label><input type="checkbox" name="languages" value="italian" ref={register} /><span data-trans="italian">Italian</span></label>
            <label><input type="checkbox" name="languages" value="other" ref={register} /><span data-trans="other">Other</span></label>
          </div>

        </fieldset>

        <fieldset>
          <legend data-trans="step4">STEP 4</legend>
          <h3 class="fieldset-title" data-trans="resumecv">Resume / C.V.</h3>
          <div>
            <label htmlFor="file" class="input-label">Attach your C.V.</label>

            <label htmlFor="file-upload" class="custom-file-upload">
              <span class="cv-file-left" id="cv-file-left"></span>
              <span class="cv-file-right" id="cv-file-right" data-trans="attach">ATTACH</span>
            </label>
            <input type="file" name="file" id="file-upload" ref={register} />
          </div>
          {errors.file && errors.file.message && <span class="field-required">{ errors.file.message }</span>}

        </fieldset>

        <fieldset>
          <legend data-trans="step5">STEP 5</legend>
          <h3 class="fieldset-title" data-trans="coverletter">Cover letter</h3>

          <div class="letter-div">
            <label htmlFor="file_2" class="input-label">Write your cover letter or </label>
            <label htmlFor="file-upload-2" class="custom-file-upload-2">
              <span class="letter-file" id="letter-file" data-trans="letter-file"> ATTACH IT</span>
              <span class="letter-file-2" id="letter-file-2"></span>
            </label>
            <input type="file" name="file_2" id="file-upload-2" ref={register} />
          </div>
          {errors.file_2 && errors.file_2.message && <span class="field-required">{ errors.file_2.message }</span>}

          <div>
            <textarea name="coverLetter" id="coverLetter" rows="12" placeholder="" ref={register({ required: true, maxLength: 400 })} />
            {errors.coverLetter && errors.coverLetter.type === "required" && <span class="field-required">*Required</span>}
            {errors.coverLetter && errors.coverLetter.type === "maxLength" && <span class="field-required">*400 characters maximum</span> }
          </div>

        </fieldset>

        <div>
          <label class="accept-label">
            <input name="accept" id="accept" type="checkbox" ref={register}/>
            <span data-trans="iaccept">I Accept the</span> <a href="#" class="form-link" data-trans="terms_and_conditions">terms and conditions</a>
          </label>
        </div>

        <div id="submit-div">
          <button type="submit" id="submit" class="kn-button-1 secondary animated fade-in-bottom"><span data-trans="submitApp">SUBMIT APPLICATION</span></button>
        </div>

        {/* <div className="email-sent">
          {isLoading && <img src={ kn_variables.template_url + '/assets/images/icons/icon_loading.gif' } className="loading-image" />}
          <div className={`success ${emailMessage && emailMessage.success === true ? "show" : "hidden"}`}>{ emailMessage.message }</div>
          <div className={`error ${emailMessage && emailMessage.success === false ? "show" : "hidden"}`}>{ emailMessage.message }</div>
        </div> */}

      </form>
    </div>
  );
}

class Form3 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <SampleForm />;
  }
}

const form3Div = document.getElementById('form-3');
ReactDOM.render(<Form3 />, form3Div);

$('#file-upload').change(function() {
  var file = $('#file-upload')[0].files[0].name;
  var fileNameDiv = $('#cv-file-left');
  fileNameDiv.text(file);
});

$('#file-upload-2').change(function() {
  var file2 = $('#file-upload-2')[0].files[0].name;
  var fileNameDiv2 = $('#letter-file-2');
  fileNameDiv2.text("("+file2+")");
});
